import React from 'react'

export default function(props) {
	const { result } = props

	return (
		<span className={'btn btn-solid'}>{result.title}</span>
	)
}